import { render } from "./AuthLayout.vue?vue&type=template&id=7476ac84"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"

import "./AuthLayout.vue?vue&type=style&index=0&id=7476ac84&lang=scss"

import exportComponent from "/Users/garay/code/omnichannel/dashboard-agente/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__